import AppMode from "../enums/AppMode"

export const getUserToken = state => {
  const { mode } = state.appConfig
  if (mode === AppMode.Terminal) {
    return state.user.terminalAuthentication.token
  }
  return state.user.authentication.token
}
